/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Elecconso1Inputs */



/**
* | output |
* | --- |
* | "Electricity consumption" |
*
* @param {Ahu_History_Key_Elecconso1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_elecconso1 = /** @type {((inputs?: Ahu_History_Key_Elecconso1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Elecconso1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Electricity consumption")
	return /** @type {LocalizedString} */ ("Consommation électrique")
});
export { ahu_history_key_elecconso1 as "ahu_history_key_elecConso" }